import React from 'react';
import classnames from 'classnames';

import Link from 'components/atoms/Link';
import Icon from 'components/atoms/Icon';

import IconArrow from 'images/icon/arrow-right.inline.svg';

import styles from './index.module.css';

interface ButtonMoreProperty {
	className?: string;
	type?: 'normal' | 'reverse';
	link?: string;
	query?: string;
	isExternal?: boolean;
}

const ButtonMore: React.FC<ButtonMoreProperty> = ({
	className,
	type = 'normal',
	link,
	query,
	isExternal = false,
}) => (
	<Link
		className={classnames(styles.buttonMore, styles[`type-${type}`], className)}
		type={isExternal ? 'external' : 'internal'}
		to={link}
		query={query}
	>
		<p className={styles.text}>查看更多</p>
		<Icon className={styles.icon} src={IconArrow} />
	</Link>
);

export default ButtonMore;
